import React from 'react';
import { CLIP_STATUS } from '../../constants/projectCreatorConsts';
import RadioButton from '../RadioButton/RadioButton';
import styles from './SelectClipsList.module.scss';
import cx from 'classnames';

const SelectClipsList = ({ className, showHeader = true, clips, selectedClips, handleChooseClip }) => {
  return (
    <div className={className}>
      {showHeader && <h3 className={styles.header}>Clips</h3>}
      <div className={styles.clipsWrapper}>
        <ul className={cx(styles.clipsList, { [styles.withScroll]: clips.length > 4 })}>
          {clips.map(clip => (
            <li key={clip.id} className={styles.clipsListItem}>
              <p
                className={styles.listName}
                onClick={() => {
                  handleChooseClip(clip);
                }}
              >
                {clip.name}
              </p>
              <RadioButton
                checked={Boolean(selectedClips?.find(item => clip.id === item))}
                onChange={() => handleChooseClip(clip)}
                className={styles.checkbox}
                variant="secondary"
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SelectClipsList;
